/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddressTriggerWorkflow } from '../models/address-trigger-workflow';
import { AddressTriggerWorkflowListResponse } from '../models/address-trigger-workflow-list-response';
import { createAddressTriggerWorkflow } from '../fn/workflows/create-address-trigger-workflow';
import { CreateAddressTriggerWorkflow$Params } from '../fn/workflows/create-address-trigger-workflow';
import { deleteAddressTriggerWorkflow } from '../fn/workflows/delete-address-trigger-workflow';
import { DeleteAddressTriggerWorkflow$Params } from '../fn/workflows/delete-address-trigger-workflow';
import { getAddressTriggerWorkflowById } from '../fn/workflows/get-address-trigger-workflow-by-id';
import { GetAddressTriggerWorkflowById$Params } from '../fn/workflows/get-address-trigger-workflow-by-id';
import { getAllAddressTriggerWorkflows } from '../fn/workflows/get-all-address-trigger-workflows';
import { GetAllAddressTriggerWorkflows$Params } from '../fn/workflows/get-all-address-trigger-workflows';
import { updateAddressTriggerWorkflow } from '../fn/workflows/update-address-trigger-workflow';
import { UpdateAddressTriggerWorkflow$Params } from '../fn/workflows/update-address-trigger-workflow';

@Injectable({ providedIn: 'root' })
export class WorkflowsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAddressTriggerWorkflows()` */
  static readonly GetAllAddressTriggerWorkflowsPath = '/api/v1/workflows/address-trigger-workflows';

  /**
   * Get all address trigger workflows.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAddressTriggerWorkflows()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAddressTriggerWorkflows$Response(params?: GetAllAddressTriggerWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflowListResponse>> {
    return getAllAddressTriggerWorkflows(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all address trigger workflows.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAddressTriggerWorkflows$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAddressTriggerWorkflows(params?: GetAllAddressTriggerWorkflows$Params, context?: HttpContext): Observable<AddressTriggerWorkflowListResponse> {
    return this.getAllAddressTriggerWorkflows$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressTriggerWorkflowListResponse>): AddressTriggerWorkflowListResponse => r.body)
    );
  }

  /** Path part for operation `createAddressTriggerWorkflow()` */
  static readonly CreateAddressTriggerWorkflowPath = '/api/v1/workflows/address-trigger-workflows';

  /**
   * Create a new address trigger workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAddressTriggerWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAddressTriggerWorkflow$Response(params: CreateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflow>> {
    return createAddressTriggerWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new address trigger workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAddressTriggerWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAddressTriggerWorkflow(params: CreateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<AddressTriggerWorkflow> {
    return this.createAddressTriggerWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressTriggerWorkflow>): AddressTriggerWorkflow => r.body)
    );
  }

  /** Path part for operation `getAddressTriggerWorkflowById()` */
  static readonly GetAddressTriggerWorkflowByIdPath = '/api/v1/workflows/address-trigger-workflows/{id}';

  /**
   * Get an address trigger workflow by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAddressTriggerWorkflowById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAddressTriggerWorkflowById$Response(params: GetAddressTriggerWorkflowById$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflow>> {
    return getAddressTriggerWorkflowById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an address trigger workflow by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAddressTriggerWorkflowById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAddressTriggerWorkflowById(params: GetAddressTriggerWorkflowById$Params, context?: HttpContext): Observable<AddressTriggerWorkflow> {
    return this.getAddressTriggerWorkflowById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressTriggerWorkflow>): AddressTriggerWorkflow => r.body)
    );
  }

  /** Path part for operation `updateAddressTriggerWorkflow()` */
  static readonly UpdateAddressTriggerWorkflowPath = '/api/v1/workflows/address-trigger-workflows/{id}';

  /**
   * Update an address trigger workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAddressTriggerWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAddressTriggerWorkflow$Response(params: UpdateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressTriggerWorkflow>> {
    return updateAddressTriggerWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an address trigger workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAddressTriggerWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAddressTriggerWorkflow(params: UpdateAddressTriggerWorkflow$Params, context?: HttpContext): Observable<AddressTriggerWorkflow> {
    return this.updateAddressTriggerWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressTriggerWorkflow>): AddressTriggerWorkflow => r.body)
    );
  }

  /** Path part for operation `deleteAddressTriggerWorkflow()` */
  static readonly DeleteAddressTriggerWorkflowPath = '/api/v1/workflows/address-trigger-workflows/{id}';

  /**
   * Delete an address trigger workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAddressTriggerWorkflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAddressTriggerWorkflow$Response(params: DeleteAddressTriggerWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAddressTriggerWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an address trigger workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAddressTriggerWorkflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAddressTriggerWorkflow(params: DeleteAddressTriggerWorkflow$Params, context?: HttpContext): Observable<void> {
    return this.deleteAddressTriggerWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
